import Swiper, { Navigation, Pagination, Autoplay, A11y } from 'swiper';
export const init = async function() {
    // configure Swiper to use modules
    Swiper.use([
        Navigation,
        Pagination,
        Autoplay,
        A11y
    ]);
    new Swiper('.js-testimonials', {
        pagination: {
            el: '.Testimonials-pagination',
            type: 'bullets',
            clickable: true,
            renderBullet: function(index, className) {
                return `<span class="${className}" id="pagination-bullet-${index}" aria-controls="testimonial-panel-${index}" aria-label="Slide ${index + 1}" role="tab"></span>`;
            }
        },
        autoplay: {
            delay: 3000,
            pauseOnMouseEnter: false,
            disableOnInteraction: true
        },
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        effect: 'slide',
        breakpoints: {
            1024: {
                slidesPerView: 'auto',
                spaceBetween: 120
            }
        },
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            paginationBulletMessage: 'Go to slide {{index}}'
        }
    });
};
